module.exports = __webpack_public_path__ + "static/Online-Retailers-95d8a3598aa8e58cdec480dcc3262916.jpg";